<script setup>
import { defineModel, defineProps } from "vue";
import Close from "@/assets/close.png";

const show = defineModel();

const { remark } = defineProps(["remark"]);
</script>

<template>
  <van-overlay :show="show" z-index="3500">
    <div class="wrapper" @click.stop>
      <div class="block">
        <div class="remark">{{ remark }}</div>
        <van-image :src="Close" class="close" @click.stop="show = false" />
      </div>
    </div>
  </van-overlay>
</template>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 32px;
}
.remark {
  box-sizing: border-box;
  width: 100%;
  padding: 24px;
  background-color: #fff;
  border-radius: 24px;
  font-size: 16px;
  line-height: 24px;
  color: #000000d9;
  font-weight: 400;
  word-break: break-all;
}
.close {
  width: 32px;
  height: 32px;
  margin-top: 16px;
}
</style>
